export const tableHeaders = [
  { label: 'ID', value: 'transactionBankingId' },
  // { label: 'Transaction ID', value: 'paymentTransactionId' },
  { label: 'Actionee', value: 'actioneeEmail' },
  { label: 'Payment Provider', value: 'paymentProvider' },
  { label: 'Amount (USD)', value: 'amount' },
  { label: 'Amount Type', value: 'amountType' },
  { label: 'Transaction Type', value: 'transactionType' },
  { label: 'Actionee Type', value: 'actioneeType' },
  { label: 'Status', value: 'status' },
  { label: 'Created At', value: 'createdAt' }
]

export const tablePlayersColumns = [
  { label: 'ID', value: 'transactionBankingId', Header: 'ID', accessor: 'transactionBankingId' },
  // { label: 'Transaction ID', value: 'paymentTransactionId', Header: 'Transaction ID', accessor: 'paymentTransactionId' },
  { label: 'Actionee', value: 'actioneeEmail', Header: 'Actionee', accessor: 'actioneeEmail' },
  { label: 'Payment Method', value: 'paymentProvider', Header: 'Payment Method', accessor: 'paymentProvider' },
  { label: 'Currency', value: 'currencyCode', Header: 'Currency', accessor: 'currencyCode' },

  { label: 'Amount', value: 'amount', Header: 'Amount', accessor: 'amount' },
  { label: 'Amount (USD)', value: 'primaryCurrencyAmount', Header: 'Amount (USD)', accessor: 'primaryCurrencyAmount' },

  { label: 'Amount Type', value: 'amountType', Header: 'Amount Type', accessor: 'amountType' },
  { label: 'Transaction Type', value: 'transactionType', Header: 'Transaction Type', accessor: 'transactionType' },
  { label: 'Actionee Type', value: 'actioneeType', Header: 'Actionee Type', accessor: 'actioneeType' },
  { label: 'Status', value: 'status', Header: 'Status', accessor: 'status' },
  { label: 'Created At', value: 'createdAt', Header: 'Created At', accessor: 'createdAt' }
];


// const depositTransactionTableHeaders = [
//   { label: 'Transaction ID', value: 'paymentTransactionId' },
//   { label: 'Voucher Code', value: 'verificationCode' },
//   { label: 'Created At', value: 'createdAt' },
//   { label: 'Actionee Name', value: 'actioneeName' },
//   { label: 'Email', value: 'email' },
//   { label: 'Actionee Type', value: 'paymentTransactionId' },
//   { label: 'Contact', value: 'contact' },
//   { label: 'Amount (TTD)', value: 'amount' },
//   { label: 'Amount (USD)', value: 'primaryCurrencyAmount' },
//   { label: 'Before Balance (USD)', value: 'beforeBalance' },
//   { label: 'Agent Name', value: 'agentName' },
//   { label: 'Status', value: 'status' },
//   { label: 'Pickup Location', value: 'pickupLocation' },
//   { label: 'Special Instructions', value: 'specialInstructions' },
//   { label: 'Payment Method', value: 'paymentMethod' },
//   { label: 'Action', value: 'action' }
// ]

const depositTransactionTableHeaders = [
  { label: 'Transaction ID', value: 'paymentTransactionId', Header: 'Transaction ID', accessor: 'transactionBankingId' },
  { label: 'Payment ID', value: 'paymentId', Header: 'Payment ID', accessor: 'transactionId' },
  { label: 'Reference ID', value: 'referenceId', Header: 'Reference ID', accessor: 'referenceId' },
  { label: 'Voucher Code', value: 'verificationCode', Header: 'Voucher Code', accessor: 'verificationCode' },
  { label: 'Created At', value: 'createdAt', Header: 'Created At', accessor: 'createdAt' },
  { label: 'Actionee Name', value: 'actioneeName', Header: 'Actionee Name', accessor: 'actioneeName' },
  { label: 'Email', value: 'email', Header: 'Email', accessor: 'actioneeEmail' },
  { label: 'Actionee Type', value: 'paymentTransactionId', Header: 'Actionee Type', accessor: 'actioneeType' },
  { label: 'Contact', value: 'contact', Header: 'Contact', accessor: 'contact' },
  { label: 'Currency', value: 'currencyCode', Header: 'Currency', accessor: 'currencyCode' },
  { label: 'Amount', value: 'amount', Header: 'Amount', accessor: 'amount' },
  { label: 'Amount (USD)', value: 'primaryCurrencyAmount', Header: 'Amount (USD)', accessor: 'primaryCurrencyAmount' },
  { label: 'Before Balance (USD)', value: 'beforeBalance', Header: 'Before Balance (USD)', accessor: 'beforeBalance' },
  { label: 'Agent Name', value: 'agentName', Header: 'Agent Name', accessor: 'agentName' },
  { label: 'Status', value: 'status', Header: 'Status', accessor: 'status' },
  { label: 'Pickup Location', value: 'pickupLocation', Header: 'Pickup Location', accessor: 'pickupLocation' },
  { label: 'Special Instructions', value: 'specialInstructions', Header: 'Special Instructions', accessor: 'specialInstructions' },
  { label: 'Payment Method', value: 'paymentMethod', Header: 'Payment Method', accessor: 'paymentMethod' },
  { label: 'Action', value: 'action', Header: 'Action', accessor: 'action' }

]

// const withdrawalTransactionTableHeaders = [
//   { label: 'Transaction ID', value: 'paymentTransactionId' },
//   { label: 'Voucher Code', value: 'verificationCode' },
//   { label: 'Created At', value: 'createdAt' },
//   { label: 'Actionee Name', value: 'actioneeName' },
//   { label: 'Email', value: 'email' },
//   { label: 'Actionee Type', value: 'paymentTransactionId' },
//   { label: 'Contact', value: 'contact' },
//   { label: 'Amount (TTD)', value: 'amount' },
//   { label: 'Amount (USD)', value: 'primaryCurrencyAmount' },
//   { label: 'Before Balance (USD)', value: 'beforeBalance' },
//   { label: 'Agent Name', value: 'agentName' },
//   { label: 'Status', value: 'status' },
//   { label: 'Withdrawal In Cash', value: 'WITHDRAWAL_IN_CASH' },
//   { label: 'Pickup Location', value: 'pickupLocation' },
//   { label: 'Special Instructions', value: 'specialInstructions' },
//   { label: 'Payment Method', value: 'paymentMethod' },
//   { label: 'Action', value: 'action' }
// ]

const withdrawalTransactionTableHeaders = [
  { label: 'Transaction ID', value: 'paymentTransactionId', Header: 'Transaction ID', accessor: 'transactionBankingId' },
  { label: 'Voucher Code', value: 'verificationCode', Header: 'Voucher Code', accessor: 'verificationCode' },
  { label: 'Created At', value: 'createdAt', Header: 'Created At', accessor: 'createdAt' },
  { label: 'Actionee Name', value: 'actioneeName', Header: 'Actionee Name', accessor: 'actioneeName' },
  { label: 'Email', value: 'email', Header: 'Email', accessor: 'actioneeEmail' },
  { label: 'Actionee Type', value: 'paymentTransactionId', Header: 'Actionee Type', accessor: 'actioneeType' },
  { label: 'Contact', value: 'contact', Header: 'Contact', accessor: 'contact' },
  { label: 'Currency', value: 'currencyCode', Header: 'Currency', accessor: 'currencyCode' },

  { label: 'Amount', value: 'amount', Header: 'Amount', accessor: 'amount' },
  { label: 'Amount (USD)', value: 'primaryCurrencyAmount', Header: 'Amount (USD)', accessor: 'primaryCurrencyAmount' },
  { label: 'Before Balance (USD)', value: 'beforeBalance', Header: 'Before Balance (USD)', accessor: 'beforeBalance' },
  { label: 'Agent Name', value: 'agentName', Header: 'Agent Name', accessor: 'agentName' },
  { label: 'Status', value: 'status', Header: 'Status', accessor: 'status' },
  { label: 'Pickup Location', value: 'pickupLocation', Header: 'Pickup Location', accessor: 'pickupLocation' },
  { label: 'Special Instructions', value: 'specialInstructions', Header: 'Special Instructions', accessor: 'specialInstructions' },
  { label: 'Payment Method', value: 'paymentMethod', Header: 'Payment Method', accessor: 'paymentMethod' },
  { label: 'Action', value: 'action', Header: 'Action', accessor: 'action' }

]

export const transactionTableHeaders = {
  deposit: depositTransactionTableHeaders,
  withdrawal: withdrawalTransactionTableHeaders
}

export const transactionTypes = [
  { label: 'Filter By Transaction Type', value: '' },
  { label: 'All', value: '' },
  { label: 'Deposit', value: 'deposit' },
  { label: 'Withdrawal', value: 'withdrawal' },
  { label: 'Add Money', value: 'addMoney' },
  { label: 'Remove Money', value: 'removeMoney' },
  { label: 'Bonus', value: 'bonus' },
  // { label: 'Bonus To Cash', value: 'bonusToCash' },
  // { label: 'Bonus Forfiet', value: 'bonusForfeit' },
  // { label: 'Bonus Expired', value: 'bonusExpired' },
  // { label: 'Bonus Zeroed Out', value: 'bonusZeroedOut' },
  // { label: 'Internal Deposit', value: 'depositInternal' },
  // { label: 'Internal Add Money', value: 'addMoneyInternal' },
  // { label: 'Internal Withdraw', value: 'withdrawInternal' },
  // { label: 'Internal Remove Money', value: 'removeMoneyInternal' }
]

export const statusType = [
  { key: 'filter-by-status', label: 'Filter by status', value: '', statusColor: '', tooltipText: '' },
  { key: 'all', label: 'All', value: '', statusColor: '', tooltipText: '' },
  { key: 'pending', label: 'Pending', value: 0, statusColor: '#1f96ff', tooltipText: 'Edit' },
  { key: 'approved', label: 'Approved', value: 4, statusColor: '#4cd9b8', tooltipText: 'Edit' },
  { key: 'success', label: 'Completed', value: 1, statusColor: 'green', tooltipText: 'Edit not allowed' },
  { key: 'failed', label: 'Failed', value: 2, statusColor: 'orangered', tooltipText: 'Edit not allowed' },
  { key: 'cancelled', label: 'Cancelled', value: 3, statusColor: '#FA812F', tooltipText: 'Cancelled by user' },
]


// export const HERO_PAYMENT_STATUS = {
//   pending: 0,
//   waiting: 1,
//   failed: 2,
//   exchanging: 3,
//   hold: 4,
//   sending: 5,
//   finished: 6,
//   confirming: 7,
//   refunded: 8,
//   expired: 9,
//   cancelled: 10
// }

export const heroPaymentStatus = [
  { key: 'pending', label: 'Pending', value: [0], statusColor: '#1f96ff', tooltipText: 'Edit' },
  { key: 'in_progress', label: 'Processing', value: [1, 7, 3, 4,], statusColor: '#FFA500', tooltipText: 'Edit' },

  { key: 'approved', label: 'Completed', value: [5, 6], statusColor: 'green', tooltipText: 'Update' },
  { key: 'failed', label: 'Failed', value: [2, 8, 9, 10], statusColor: 'orangered', tooltipText: 'Update not allowed' },
]

export const heroPaymentStatusWithdrawl = [
  { key: 'pending', label: 'Pending', value: [0], statusColor: '#1f96ff', tooltipText: 'Edit' },
  { key: 'in_progress', label: 'Processing', value: [1, 7, 3, 4, 5], statusColor: '#FFA500', tooltipText: 'Edit' },

  { key: 'approved', label: 'Completed', value: [6], statusColor: 'green', tooltipText: 'Update' },
  { key: 'failed', label: 'Failed', value: [2, 8, 10], statusColor: 'orangered', tooltipText: 'Update not allowed' },
]

export const depositCryptoCheck = [0, 5, 6, 2, 8, 9, 10]
export const withdrawlCryptoCheck = [6, 2, 8, 9, 10]
export const paymentMethods = [
  { label: 'All', value: '' },
  { label: 'Voucher', value: 'Voucher' },
  { label: 'Bank Transfer', value: 'Bank Transfer' },
  { label: 'Crypto', value: 'Crypto' },
  { label: 'Cash Deposit', value: 'Cash Agency' },
  { label: 'Promo Codes', value: 'PromoCodes' },
  { label: 'Voucher Codes', value: 'VoucherCodes' },
]

export const paymentMethodsWithdrawal = [
  { label: 'All', value: '' },
  { label: 'Voucher', value: 'Voucher' },
  { label: 'Bank Transfer', value: 'Bank Transfer' },
  { label: 'Crypto', value: 'Crypto' },
  { label: 'Cash Withdrawal', value: 'Cash Agency' },
  { label: 'Promo Codes', value: 'PromoCodes' },
  { label: 'Voucher Codes', value: 'VoucherCodes' },
]

export const CURRENCY_CODES = {
  USD: '$',
  EUR: '€'
}

export const AMOUNT_TYPE = {
  0: 'Cash',
  1: 'Non-Cash'
}

export const walletType = ['Cash', 'Bonus']

// export const depositBankingDetailsHeaders = [
//   { label: 'Bank Name', value: 'bankName' },
//   { label: 'RT Number', value: 'rtNumber' },
//   { label: 'Account Holder', value: 'accountHolderName' },
//   { label: 'Account Number', value: 'accountNumber' },
//   { label: 'Account Type', value: 'accountType' },
//   { label: 'Place', value: 'place' },
//   { label: 'Status', value: 'status' },
//   { label: 'Action', value: 'action' }
// ]

export const depositBankingDetailsHeaders = [
  { accessorKey: 'bank_details_id', Header: 'id', value: 'bank_details_id', label: 'id', isRequired: false, isShowModal: false, },
  { accessorKey: 'bankName', Header: 'Bank Name', value: 'bankName', label: 'Bank Name', isRequired: true, isShowModal: true, },
  { accessorKey: 'rtNumber', Header: 'RT Number', value: 'rtNumber', label: 'RT Number', isRequired: false, isShowModal: true },
  { accessorKey: 'accountHolderName', Header: 'Account Holder', value: 'accountHolderName', label: 'Account Holder', isRequired: false, isShowModal: true },
  { accessorKey: 'accountNumber', Header: 'Account Number', value: 'accountNumber', label: 'Account Number', isRequired: true, isShowModal: true },
  { accessorKey: 'accountType', Header: 'Account Type', value: 'accountType', label: 'Account Type', isRequired: true, isShowModal: true },
  { accessorKey: 'place', Header: 'Place', value: 'place', label: 'Place', isRequired: false, isShowModal: true },
  { accessorKey: 'status', Header: 'Status', value: 'status', label: 'Status', isRequired: false, isShowModal: true },
  { accessorKey: 'action', Header: 'Action', value: 'action', label: 'Action', isShowModal: false }
];


// export const withdrawalBankingDetailsHeaders = [
//   { label: 'Bank Name', value: 'bankName' },
//   { label: 'RT Number', value: 'rtNumber' },
//   { label: 'Status', value: 'status' },
//   { label: 'Action', value: 'action' }
// ]

export const withdrawalBankingDetailsHeaders = [
  { accessorKey: 'bank_details_id', Header: 'id', value: 'bank_details_id', label: 'id', isRequired: false, isShowModal: false },

  { accessorKey: 'bankName', Header: 'Bank Name', value: 'bankName', label: 'Bank Name', isRequired: true, isShowModal: true },
  { accessorKey: 'rtNumber', Header: 'RT Number', value: 'rtNumber', label: 'RT Number', isRequired: true, isShowModal: true },
  { accessorKey: 'status', Header: 'Status', value: 'status', label: 'Status', isRequired: false, isShowModal: true },
  { accessorKey: 'action', Header: 'Action', value: 'action', label: 'Action', isRequired: true, isShowModal: false }
];

